export default __webpack_public_path__ + "static/plp--bundle--mixed-c6c2d66fc468ad63fbeae0e22417519f.png";